import { selectors } from '@elab/core/store/cart';
import { selectors as checkoutSelectors } from '@elab/core/store/checkout';
import { selectors as configSelectors } from '@elab/core/store/config';
import { selectors as orderSelectors } from '@elab/core/store/order';
import { selectors as paymentSelectors } from '@elab/core/store/payment';
import connect from '@elab/core/store/connect';
import { getActions } from '@elab/components/connected/forms/CheckoutAddressForms/redux';
import { DeliveryAddress } from '@elab/components/connected/DeliveryAddress';

const mapDispatchToEvents = dispatch => ({
    'edit-address-in-popup': ({
        detail: {
            id,
            storeName,
            addressType,
            radioView,
            useCartUrlForEdit,
            useCartUrlForAdd,
            submitEditMethod,
            selectForPaymentAfterEditing,
        },
    }) =>
        dispatch(
            getActions(storeName).openFormInDialog({
                id,
                addressType,
                radioView,
                useCartUrlForEdit,
                useCartUrlForAdd,
                submitEditMethod,
                selectForPaymentAfterEditing,
            }),
        ),
});

const mapStateToProps = (state, ctx) => {
    const addressForBilling = ctx.orderDetailAddress
        ? orderSelectors.getPaymentAddress(state)
        : checkoutSelectors.getAddressForBilling(state);

    const deliveryAddress =
        ctx.allowDeliveryAsBilling && addressForBilling && Object.keys(addressForBilling).length
            ? addressForBilling
            : selectors.getPaymentAddress(state);
    const showCorporateOptionFields = configSelectors.getShowCorporateOptionFields(state);

    const isPaymentPage = paymentSelectors.getIsPaymentPage(state);

    return { deliveryAddress, showCorporateOptionFields, isPaymentPage };
};

export default () =>
    customElements.define(
        'e2-payment-address',
        connect(mapStateToProps, mapDispatchToEvents)(DeliveryAddress),
    );
